import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { environment } from 'src/environments/environment';
import { IPersonVehicle } from '../interfaces/person-vehicle.interface';

@Injectable({
  providedIn: 'root'
})
export class PersonVehicleService {
  private apiUrl = environment.backUrlApi + 'PersonVehicle';
  private http = inject(HttpClient);

  /** Obtener todos los vehículos de un candidato */
  getAllByCandidate(idEncript: string): Observable<ResponseModel<IPersonVehicle[]>> {
    return this.http.get<ResponseModel<IPersonVehicle[]>>(`${this.apiUrl}/candidate/all/?id=${encodeURIComponent(idEncript)}`);
  }

  /** Registrar un nuevo vehículo para un candidato */
  add(idEncript: string, vehicle: any): Observable<ResponseModel<any>> {
    return this.http.post<ResponseModel<any>>(`${this.apiUrl}/candidate/?id=${encodeURIComponent(idEncript)}`, vehicle);
  }

  /** Registrar un nuevo vehículo vacio para un candidato */
  addEmpty(idEncript: string): Observable<ResponseModel<any>> {
    return this.http.post<ResponseModel<any>>(`${this.apiUrl}/candidate/no-vehicle/?id=${encodeURIComponent(idEncript)}`, {});
  }

  /** Actualizar la información de un vehículo de un candidato */
  update(idEncript: string, vehicle: any): Observable<ResponseModel<any>> {
    return this.http.put<ResponseModel<any>>(`${this.apiUrl}/candidate/?id=${encodeURIComponent(idEncript)}`, vehicle);
  }

  /** Eliminar lógicamente un vehículo de un candidato */
  delete(idEncript: string, idVehicle: number): Observable<ResponseModel<any>> {
    return this.http.delete<ResponseModel<any>>(`${this.apiUrl}/candidate/?id=${encodeURIComponent(idEncript)}&idVehicle=${idVehicle}`);
  }
}
